import Entity from '../entity'
export default class Language extends Entity<number> {
    name: string = "";
    icon: string = "";
    isEnabled: boolean = true;
}